export default __webpack_public_path__ + "static/media/seat-rectangle.fe5e438b.webp";